import { Box, Grid, Stack } from "@mui/material";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";
import { RegistrationCard } from "./RegistrationCard";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import { SSText } from "src/components/base/components/SSText";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export function RegistrationCardContainer(props: {
  hideTitle?: boolean;
  title?: string | React.ReactNode;
  cards?: TRegistrationCardData[];
  isExpandedCard?: boolean;
  cardProps?: {
    onClickCTA?: (cardItem: TRegistrationCardData) => Promise<void>;
  };
}) {
  const theme = useSSTheme();
  const { md: mdUp } = useCssMediaQuery("up");

  const gridSizes = props?.isExpandedCard
    ? { xs: 12, sm: 10, md: 8, lg: 6 }
    : { xs: 12, sm: 6, lg: 4 };

  return (
    <Stack spacing={2}>
      {!props?.hideTitle ? (
        <Box textAlign={"center"}>
          <SSText variant="h6" fontWeight={700} color={theme.colors.gray[200]}>
            {props?.title || "Single Game Tickets"}
          </SSText>
        </Box>
      ) : null}

      <Box>
        <Grid container spacing={3} justifyContent={"center"}>
          {props?.cards?.map((itm, idx) => {
            return (
              <Grid item key={idx} {...gridSizes}>
                <RegistrationCard cardData={itm} {...props?.cardProps} />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Stack>
  );
}
